<script>
import {getDevItemCaptions} from './archetype'
import _ from 'lodash'
export default {
    name: 'DevolucionesGeneralHandler',
    props: {
        origen: {
            type: String,
            required: true
        },
        readonly: {
            type: Boolean,
            default: false
        },
        value: {
            type: Array,
            default: () => {return []}
        },
        devolucionDetalles: {
            type: Array,
            required: true
        },
        captions: {
            type: Array,
            default: getDevItemCaptions
        }
    },
    data: () => {
        return {
            workingValue: []
        }
    },
    methods: {
        loadUpValue(){
            if(this.devolucionDetalles && JSON.stringify(this.devolucionDetalles) != JSON.stringify(this.workingValue)){
                this.workingValue = _.cloneDeep(this.devolucionDetalles)
                this.$emit('input', this.workingValue)
            }
        }
    },
    mounted(){
        this.loadUpValue()
    },
    watch: {
        devolucionDetalles(){
            this.loadUpValue()
        }
    }
}
</script>

<template>
    <b-card id="DevolucionesGeneralHandler" no-body header="Detalle de la solicitud">
        <b-table :items="workingValue" :small="true" :fields="captions"  :responsive="true">

            <template #cell(cantidad_devuelta)="data">
                <b-input-group size="xs">
                    <!-- <template #append> -->
                        <!-- <b-input-group-text>asdf</b-input-group-text> -->
                    <!-- </template> -->
                    <b-input v-model="workingValue[data.index].cantidad_devuelta" min="0" :max="data.item.cantidad" type="number" @change="$emit('input', workingValue)" :disabled="readonly"/>
                </b-input-group>
            </template>

            <template #cell(costo)="data">
                <b-input-group size="xs">
                    <template #prepend>
                        <b-input-group-text>$</b-input-group-text>
                    </template>
                    <b-input v-model="workingValue[data.index].costo" min="0" type="number" @change="$emit('input', workingValue)" :disabled="readonly || origen == 'Devolucion cocina'"/>
                </b-input-group>
            </template>

            <template #cell(precio)="data">
                <b-input-group size="xs">
                    <template #prepend>
                        <b-input-group-text>$</b-input-group-text>
                    </template>
                    <b-input v-model="workingValue[data.index].precio" min="0" type="number" @change="$emit('input', workingValue)" :disabled="readonly || origen == 'Devolucion cocina'"/>
                </b-input-group>
            </template>

        </b-table>
    </b-card>
</template>

<style lang="less">
#DevolucionesGeneralHandler {


    .b-table-sticky-header, .table-responsive, [class*="table-responsive-"] {
        /* margin-bottom: 1rem; */
        margin-bottom: 0;
    }

    .table th, .table td {
        /* vertical-align: baseline; */
        vertical-align: middle;
    }
}
</style>